/**
 * @fileoverview gRPC-Web generated client stub for pb.v1alpha1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: v1alpha1/auth.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as v1alpha1_auth_pb from '../v1alpha1/auth_pb'; // proto import: "v1alpha1/auth.proto"


export class AuthServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorRegister = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/Register',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.RegisterRequest,
    v1alpha1_auth_pb.RegisterResponse,
    (request: v1alpha1_auth_pb.RegisterRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.RegisterResponse.deserializeBinary
  );

  register(
    request: v1alpha1_auth_pb.RegisterRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.RegisterResponse>;

  register(
    request: v1alpha1_auth_pb.RegisterRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RegisterResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.RegisterResponse>;

  register(
    request: v1alpha1_auth_pb.RegisterRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RegisterResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/Register',
        request,
        metadata || {},
        this.methodDescriptorRegister,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/Register',
    request,
    metadata || {},
    this.methodDescriptorRegister);
  }

  methodDescriptorLogin = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/Login',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.LoginRequest,
    v1alpha1_auth_pb.LoginResponse,
    (request: v1alpha1_auth_pb.LoginRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.LoginResponse.deserializeBinary
  );

  login(
    request: v1alpha1_auth_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.LoginResponse>;

  login(
    request: v1alpha1_auth_pb.LoginRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.LoginResponse>;

  login(
    request: v1alpha1_auth_pb.LoginRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/Login',
        request,
        metadata || {},
        this.methodDescriptorLogin,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/Login',
    request,
    metadata || {},
    this.methodDescriptorLogin);
  }

  methodDescriptorRegisterWithGoogle = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/RegisterWithGoogle',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.RegisterWithGoogleRequest,
    v1alpha1_auth_pb.RegisterResponse,
    (request: v1alpha1_auth_pb.RegisterWithGoogleRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.RegisterResponse.deserializeBinary
  );

  registerWithGoogle(
    request: v1alpha1_auth_pb.RegisterWithGoogleRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.RegisterResponse>;

  registerWithGoogle(
    request: v1alpha1_auth_pb.RegisterWithGoogleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RegisterResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.RegisterResponse>;

  registerWithGoogle(
    request: v1alpha1_auth_pb.RegisterWithGoogleRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RegisterResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/RegisterWithGoogle',
        request,
        metadata || {},
        this.methodDescriptorRegisterWithGoogle,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/RegisterWithGoogle',
    request,
    metadata || {},
    this.methodDescriptorRegisterWithGoogle);
  }

  methodDescriptorLoginWithGoogle = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/LoginWithGoogle',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.LoginWithGoogleRequest,
    v1alpha1_auth_pb.LoginResponse,
    (request: v1alpha1_auth_pb.LoginWithGoogleRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.LoginResponse.deserializeBinary
  );

  loginWithGoogle(
    request: v1alpha1_auth_pb.LoginWithGoogleRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.LoginResponse>;

  loginWithGoogle(
    request: v1alpha1_auth_pb.LoginWithGoogleRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LoginResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.LoginResponse>;

  loginWithGoogle(
    request: v1alpha1_auth_pb.LoginWithGoogleRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LoginResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/LoginWithGoogle',
        request,
        metadata || {},
        this.methodDescriptorLoginWithGoogle,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/LoginWithGoogle',
    request,
    metadata || {},
    this.methodDescriptorLoginWithGoogle);
  }

  methodDescriptorRefreshToken = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/RefreshToken',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.RefreshTokenRequest,
    v1alpha1_auth_pb.RefreshTokenResponse,
    (request: v1alpha1_auth_pb.RefreshTokenRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.RefreshTokenResponse.deserializeBinary
  );

  refreshToken(
    request: v1alpha1_auth_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.RefreshTokenResponse>;

  refreshToken(
    request: v1alpha1_auth_pb.RefreshTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RefreshTokenResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.RefreshTokenResponse>;

  refreshToken(
    request: v1alpha1_auth_pb.RefreshTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.RefreshTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/RefreshToken',
        request,
        metadata || {},
        this.methodDescriptorRefreshToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/RefreshToken',
    request,
    metadata || {},
    this.methodDescriptorRefreshToken);
  }

  methodDescriptorLogout = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/Logout',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.LogoutRequest,
    v1alpha1_auth_pb.LogoutResponse,
    (request: v1alpha1_auth_pb.LogoutRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.LogoutResponse.deserializeBinary
  );

  logout(
    request: v1alpha1_auth_pb.LogoutRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.LogoutResponse>;

  logout(
    request: v1alpha1_auth_pb.LogoutRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LogoutResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.LogoutResponse>;

  logout(
    request: v1alpha1_auth_pb.LogoutRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LogoutResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/Logout',
        request,
        metadata || {},
        this.methodDescriptorLogout,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/Logout',
    request,
    metadata || {},
    this.methodDescriptorLogout);
  }

  methodDescriptorGetProfile = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/GetProfile',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.GetProfileRequest,
    v1alpha1_auth_pb.GetProfileResponse,
    (request: v1alpha1_auth_pb.GetProfileRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.GetProfileResponse.deserializeBinary
  );

  getProfile(
    request: v1alpha1_auth_pb.GetProfileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.GetProfileResponse>;

  getProfile(
    request: v1alpha1_auth_pb.GetProfileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.GetProfileResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.GetProfileResponse>;

  getProfile(
    request: v1alpha1_auth_pb.GetProfileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.GetProfileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/GetProfile',
        request,
        metadata || {},
        this.methodDescriptorGetProfile,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/GetProfile',
    request,
    metadata || {},
    this.methodDescriptorGetProfile);
  }

  methodDescriptorLinkGoogleAccount = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.AuthService/LinkGoogleAccount',
    grpcWeb.MethodType.UNARY,
    v1alpha1_auth_pb.LinkGoogleAccountRequest,
    v1alpha1_auth_pb.LinkGoogleAccountResponse,
    (request: v1alpha1_auth_pb.LinkGoogleAccountRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_auth_pb.LinkGoogleAccountResponse.deserializeBinary
  );

  linkGoogleAccount(
    request: v1alpha1_auth_pb.LinkGoogleAccountRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_auth_pb.LinkGoogleAccountResponse>;

  linkGoogleAccount(
    request: v1alpha1_auth_pb.LinkGoogleAccountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LinkGoogleAccountResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_auth_pb.LinkGoogleAccountResponse>;

  linkGoogleAccount(
    request: v1alpha1_auth_pb.LinkGoogleAccountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_auth_pb.LinkGoogleAccountResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.AuthService/LinkGoogleAccount',
        request,
        metadata || {},
        this.methodDescriptorLinkGoogleAccount,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.AuthService/LinkGoogleAccount',
    request,
    metadata || {},
    this.methodDescriptorLinkGoogleAccount);
  }

}

